// extracted by mini-css-extract-plugin
export var box = "_1e-2";
export var checkboxControl = "_1e-0";
export var checkboxRow = "_1e-a";
export var checked = "_1e-3";
export var descriptionSpacer = "_1e-c";
export var disabled = "_1e-4";
export var icon = "_1e-8";
export var input = "_1e-1";
export var labelSpacer = "_1e-b";
export var large = "_1e-7";
export var medium = "_1e-6";
export var small = "_1e-5";
export var text = "_1e-9";